<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('user.inviteRecord')"
      @backurl="$router.back()"
    />
    <div class="item_wrap">
      <div class="item_list">
        <van-list
          v-model="loading"
          loading-text=" "
          offset="0"
          :finished="finished"
          :finished-text="$t('utils.noData')"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            class="block_div item"
          >
            <div class="flex_center time">
              <p>{{ item.time_actual }}</p>
              <p
                v-if="item.status==0"
                class="color_blue"
              >
                {{ $t('tabs.ongoing') }}
              </p>
              <p
                v-if="item.status==1"
                class="color_green"
              >
                {{ $t('tabs.done') }}
              </p>
            </div>
            <div class="detail">
              <div class="title">
                {{ item.title }}
              </div>
              <van-cell-group :border="false">
                <van-cell
                  value-class="value_class"
                  :value="common.currency_symbol_basic()+common.precision_basic(item.money)"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/toum.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('invest.amount') }}</span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="item.day+(item.type==3?$t('index.hour'):$t('index.day'))"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/zhoum.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('invest.cycle') }}</span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="item.rate+'%'"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                       src="../img/user/lilv.png"
                       alt=""
                       style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                     >
                      <span v-if="item.type==1">
                        {{ $t('index.dailyRate') }}
                      </span>
                      <span v-else>
                        {{ $t('index.rate') }}
                      </span>
                    </span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="common.currency_symbol_basic()+common.precision_basic(item.total_interest)"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/lixi.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('invest.income') }}</span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="common.currency_symbol_basic()+common.precision_basic(item.total)"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/zong.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('utils.goodszong') }}</span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="$t('index.method'+item.type)"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/leix.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('invest.type') }}</span>
                  </template>
                </van-cell>
                <van-cell
                  value-class="value_class"
                  :value="item.time2_actual"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      style="line-height: 24px;"
                    ><img
                      src="../img/user/dao.png"
                      alt=""
                      style="vertical-align: middle;height: 24px;width: 24px;margin-right: 5px"
                    >{{ $t('invest.endTime') }}</span>
                  </template>
                </van-cell>
                <!-- 	<van-cell :title="$t('invest.amount')" value-class="value_class" :border="false"
									:value="common.currency_symbol_basic()+common.precision_basic(item.money)" >
								</van-cell> -->
                <!-- 	<van-cell :title="$t('invest.cycle')" value-class="value_class" :border="false"
									:value="item.day+(item.type==3?$t('index.hour'):$t('index.day'))" /> -->
                <!-- 	<van-cell :title="item.type==1?$t('index.dailyRate'):$t('index.rate')"
									value-class="value_class" :border="false" :value="item.rate+'%'" /> -->
                <!-- <van-cell :title="$t('invest.income')" value-class="value_class" :border="false"
									:value="common.currency_symbol_basic()+common.precision_basic(item.total_interest)" />	 -->
                <!-- <van-cell :title="$t('utils.goodszong')" value-class="value_class" :border="false"
									:value="common.currency_symbol_basic()+common.precision_basic(item.total)" />	 -->
                <!-- <van-cell :title="$t('invest.type')" value-class="value_class" :border="false"
									:value="$t('index.method'+item.type)" /> -->
                <!-- <van-cell :title="$t('invest.endTime')" value-class="value_class" :border="false"
									:value="item.time2_actual" /> -->
              </van-cell-group>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import {
		List,
		Cell,
		CellGroup
	} from 'vant';
	Vue.use(List).use(Cell).use(CellGroup);
	export default {
		name: "Recharge",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				loading: false,
				finished: false,
				list: [],
				page: 1,
				listRows: 8
			};
		},
		// //创建前设置
		// beforeCreate() {
		// 	//解决List上拉加载bug
		// 	document.querySelector('body').style["overflow-y"] = "unset";
		// },
		// //销毁前清除
		// beforeDestroy() {
		// 	document.querySelector('body').style["overflow-y"] = "scroll";
		// },
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FFFFFF');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('user', false);
		},
		mounted() {},
		methods: {
			sort(type) {
				this.page = 1;
				this.list = [];
				this.finished = false;
				this.loading = true;
				this.onLoad();
			},
			onLoad() {

				Fetch('/user/investRecord', {
					page: this.page,
					listRows: this.listRows
				}).then(r => {
					var list = r.data.list;
					for (var i = 0; i < list.length; i++) {
						this.list.push(list[i]);
					}
					if (this.list.length >= r.data.length) {
						this.finished = true;
						return;
					}
					this.page = this.page + 1;
					this.loading = false;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap{
		padding-bottom: 60px;
		background: #000;height: 100%;min-height: 100vh
	}
	.item_wrap {
		width: 100%;
		padding: 18px 0 0 0;

		.item_list {
			margin-top: 10px;

			.item {
				padding: 20px;
				background: #FFFFFF;
				margin-bottom: 10px;

				.time {
					margin-bottom: 20px;
					justify-content: space-between;
					border-bottom: 1px solid #ECECEC;
					padding-bottom: 15px;
					color: #999;

					p:nth-child(1) {
						text-align: left;
					}

					p:nth-child(2) {
						text-align: right;
					}
				}

				.detail {
					line-height: 2;

					.title {
						font-size: 14px;
						font-weight: bold;
						margin-bottom: 10px;
					}

					.value_class {
						font-weight: bold;
						color: #3CB371;
					}
				}

			}

		}
	}

	/deep/ .van-cell {
		font-size: unset;
		margin-top: 5px;
		padding: 5px 0;
	}
</style>
